import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex.ts';

import type { ReservationType } from 'src/features/reservations/types/reservationType.ts';

const RESOURCE = '/reservations/:parkingId/vehicle-stay-reservation-type/:versionId/';

interface DTO {
    parkingId: string;
    versionId: string;
}

type ReservationTypeByVersionIdQueryFnType = typeof getReservationTypeByVersionId;

interface UseReservationTypeList extends DTO {
    config?: QueryConfig<ReservationTypeByVersionIdQueryFnType>;
}

export const getReservationTypeByVersionId = ({ parkingId, versionId, ...params }: DTO): Promise<ReservationType> => {
    if (!versionId) {
        throw new Error('Reservation versionId must be defined');
    }
    return axios.get(formatResourcePath(RESOURCE, { parkingId, versionId }), { params });
};

export const useReservationTypeByVersionId = ({ config, ...payload }: UseReservationTypeList) => {
    return useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await getReservationTypeByVersionId(payload),
        ...config,
    });
};
